// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpMenu } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const Menu = wrap(jpMenu());
// @ts-expect-error unknown property
Menu.displayName = 'Jupyter.Menu';
